export default {
  summary_one: 'Se eliminó {{count}} artículo · no disponible para tu hora de recogida',
  summary_other: 'Se eliminaron {{count}} artículos · no disponibles para tu hora de recogida',
  reason: 'Solo disponible {{schedule}} — tu recogida es a las {{time}}.',
  change_pickup_time: 'Cambiar hora de recogida',
  dismiss: 'Descartar',
};
